<div id="loader_wrapper">
    <span class="loader"></span>
  </div>